var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FileWidget as _FileWidget } from '../angular2-schema-form-shim';
import { isWidgetRequired } from './overrides';
var FileWidget = (function (_super) {
    __extends(FileWidget, _super);
    function FileWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FileWidget.prototype, "required", {
        get: function () {
            return isWidgetRequired(this);
        },
        enumerable: true,
        configurable: true
    });
    return FileWidget;
}(_FileWidget));
export { FileWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/file.widget.ts.pre-build-optimizer.js